import { render, staticRenderFns } from "./rich-text-viewer.component.vue?vue&type=template&id=bf6967f0"
import script from "./rich-text-viewer.component.vue?vue&type=script&lang=js"
export * from "./rich-text-viewer.component.vue?vue&type=script&lang=js"
import style0 from "./rich-text-viewer.component.vue?vue&type=style&index=0&id=bf6967f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports